import React from 'react';

const MembershipPlanFormModal = React.lazy(() => import('../components/FormModal'));
const membershipPlanModalRegistry = {
    core_membershipPlanId: MembershipPlanFormModal
};
export default membershipPlanModalRegistry;
